/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Validation_Total_PositiveInputs */

const en_case_payment_validation_total_positive = /** @type {(inputs: Case_Payment_Validation_Total_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The total amount must be greater than zero.`)
};

const pt_br2_case_payment_validation_total_positive = /** @type {(inputs: Case_Payment_Validation_Total_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O valor total deve ser maior que zero.`)
};

/**
* | output |
* | --- |
* | "The total amount must be greater than zero." |
*
* @param {Case_Payment_Validation_Total_PositiveInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_validation_total_positive = /** @type {((inputs?: Case_Payment_Validation_Total_PositiveInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Validation_Total_PositiveInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_validation_total_positive(inputs)
	return pt_br2_case_payment_validation_total_positive(inputs)
});